const STATE = { DEAD: 'D', ALIVE: 'A' }

export default STATE;
